import React from 'react';
import AppRoutes from './AppRoutes';

const App: React.FC = () => <AppRoutes />;

export default App;
